module.exports = __webpack_public_path__ + "static/media/ship.d18f249a.png";